import { Component, Vue } from 'vue-facing-decorator';
import template from './cancelRequestBtn.html?raw';

@Component({
  template,
  inheritAttrs: false,
})
export default class CancelRequestBtn extends Vue {
  public openDialog = false;

  public onCancelRequest(cb: () => void) {
    this.$emit('cancelled');

    cb();
  }

  public openCancellationDialog() {
    this.openDialog = true;
  }
}
